import React from 'react';
import { Outlet } from 'react-router-dom';

import SansmrutiNavbar from '../SansmrutiNavbar';
import Footer from '../Footer'; 

const SansmrutiPublicationLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      
      {/* 1. Navbar */}
      <SansmrutiNavbar />

      {/* 2. Border Image -  */}
      <img src="/images/border.png" className="w-full h-auto" alt="border" />

      {/* 3. Main Content Area */}
      <main className="flex-grow">
        <Outlet />
      </main>

      {/* 4. Footer */}
      <Footer />
    </div>
  );
};

export default SansmrutiPublicationLayout;